import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { ChevronLeft } from '@styled-icons/material/ChevronLeft';
import { ChevronRight } from '@styled-icons/material/ChevronRight';
import { Close } from '@styled-icons/material/Close';
import { spacing, themeLight } from '@naf/theme';
import { propValidationConfig } from './propValidationConfig';
const renderIcon = icon => {
  switch (icon) {
    case 'arrow-right':
      return /*#__PURE__*/React.createElement(ChevronRight, {
        size: 24
      });
    case 'arrow-left':
      return /*#__PURE__*/React.createElement(ChevronLeft, {
        size: 24
      });
    case 'close':
      return /*#__PURE__*/React.createElement(Close, {
        size: 24
      });
    default:
      return null;
  }
};
export const IconButton = ({
  variant = 'outline',
  onClick,
  ariaLabel,
  icon,
  className,
  disabled = false
}) => {
  const [mouseDown, setMouseDown] = useState(false);
  const removeOutline = () => {
    setMouseDown(true);
  };
  const addOutline = e => {
    if (e.key === 'Tab') {
      setMouseDown(false);
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', removeOutline);
    return () => window.removeEventListener('mousedown', removeOutline);
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', addOutline);
    return () => window.removeEventListener('keydown', addOutline);
  }, []);
  return /*#__PURE__*/React.createElement(Button, {
    onClick: !disabled ? () => onClick() : null,
    "aria-label": ariaLabel,
    className: className,
    id: mouseDown ? 'mousedown' : '',
    disabled: disabled,
    variant: variant
  }, renderIcon(icon));
};
export default IconButton;
const Button = styled.button.withConfig(propValidationConfig).withConfig({
  displayName: "icon-button__Button",
  componentId: "sc-i8h2z1-0"
})(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;appearance:none;touch-action:manipulation;width:", ";height:", ";background-color:", ";display:flex;justify-content:center;align-items:center;border-radius:50%;transition:0.2s ease;&:active,&:focus{border-radius:50% !important;}&:hover{cursor:pointer;background-color:", ";}svg{color:", ";}", " ", " ", " ", " ", " ", " &#mousedown{outline:0;}"], spacing.space40, spacing.space40, ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  variant
}) => variant === 'primary' && css(["background-color:", ";svg{color:", ";}&:hover{background-color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.primary : themeLight.componentColors.cta.primary, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.primaryHover : themeLight.componentColors.cta.primaryHover), ({
  variant
}) => variant === 'secondary' && css(["background-color:", ";svg{color:", ";}&:hover{background-color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondary : themeLight.componentColors.cta.secondary, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryHover : themeLight.componentColors.cta.secondaryHover), ({
  variant
}) => variant === 'secondary-inverted' && css(["background-color:", ";svg{color:", ";}&:hover{background-color:", ";svg{color:", ";}}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryInverted : themeLight.componentColors.cta.secondaryInverted, ({
  theme
}) => theme.typography ? theme.typography.brandTextInverted : themeLight.typography.brandTextInverted, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryInvertedHover : themeLight.componentColors.cta.secondaryInvertedHover, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText), ({
  variant
}) => variant === 'outline' && css(["border:1px solid ", ";&:hover{border:1px solid ", ";}", ""], ({
  theme
}) => theme.border.heavy || themeLight.border.heavy, ({
  theme
}) => theme.border.default || themeLight.border.default, ({
  disabled
}) => disabled && css(["border:1px solid ", ";"], ({
  theme
}) => theme.border.default || themeLight.border.default)), ({
  variant
}) => variant === 'neutral' && css(["background-color:", ";&:hover{background-color:", ";svg{color:", ";}}&:active{background-color:", ";svg{color:", ";}}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.disabled : themeLight.componentColors.cta.disabled, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondary : themeLight.componentColors.cta.secondary, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryInverted : themeLight.componentColors.cta.secondaryInverted, ({
  theme
}) => theme.typography ? theme.componentColors.cta.secondary : themeLight.componentColors.cta.secondary), ({
  disabled
}) => disabled && css(["&:not(:hover),&:hover{cursor:initial;background:", ";svg{color:", ";}}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.disabled : themeLight.componentColors.cta.disabled, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText));
//# sourceMappingURL=icon-button.js.map